package org.bsvac.bsvac_kmp.data.models

enum class RadioModel(val displayString: String) {
    NYPD_1("NYPD 1"),
    NYPD_2("NYPD 2"),
    NYPD_3("NYPD 3"),
    NYPD_4("NYPD 4"),
    NYPD_5("NYPD 5"),
    PORT_1("PORT 1"),
    PORT_2("PORT 2"),
    PORT_3("PORT 3"),
    PORT_4("PORT 4"),
    PORT_5("PORT 5"),
    PORT_6("PORT 6"),
    RADIO_1("RADIO 1"),
    RADIO_2("RADIO 2"),
    RADIO_3("RADIO 3"),
    RADIO_4("RADIO 4"),
    RADIO_5("RADIO 5");

    companion object {
        fun validEntries(selectedAgency: AgencyModel?): List<RadioModel> {
            return when (selectedAgency) {
                AgencyModel.BSVAC -> listOf(
                    NYPD_1,
                    NYPD_2,
                    NYPD_3,
                    NYPD_4,
                    NYPD_5,
                    PORT_1,
                    PORT_2,
                    PORT_3,
                    PORT_4,
                    PORT_5,
                    PORT_6
                )
                AgencyModel.GVEMS -> listOf(
                    RADIO_1,
                    RADIO_2,
                    RADIO_3,
                    RADIO_4,
                    RADIO_5
                    )
                null -> emptyList()
            }
        }

    }
}